(() => {
  if (window.__singlefileBottleLimitInit) return;
  window.__singlefileBottleLimitInit = true;

  async function getCart() {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    return res.json();
  }

  function productQtyInCart(cart, productId) {
    return cart.items
      .filter((item) => String(item.product_id) === String(productId))
      .reduce((total, item) => total + item.quantity, 0);
  }

  function showMessage(container, limit) {
  if (!container) return;

  const productCard = container.closest('product-card');

  if (productCard) {
    const permanentMsg = productCard.querySelector('.product-card__bottle-limit-message');

    if (permanentMsg) {
      permanentMsg.setAttribute('role', 'alert');
      permanentMsg.textContent = `Limit of ${limit} bottles per customer.`;
      return;
    }
  }

  let msg = container.querySelector('.bottle-limit-message');

  if (!msg) {
    msg = document.createElement('div');
    msg.className = 'bottle-limit-message';
    msg.setAttribute('role', 'alert');
    msg.style.marginTop = '8px';
    msg.style.color = '#b42318';
    msg.style.fontSize = '0.9rem';
    container.appendChild(msg);
  }

  msg.textContent = `Limit of ${limit} bottles per customer.`;
}

  function setCollectionUI(wrapper, qty, limit) {
    if (!wrapper) return;

    const form = wrapper.querySelector('product-form');
    const qtyBox = wrapper.querySelector('.collection-qty');
    const qtyValue = wrapper.querySelector('.qty-value');
    const plusBtn = wrapper.querySelector('.qty-plus');

    if (!form || !qtyBox || !qtyValue) return;

    if (qty > 0) {
      form.style.display = 'none';
      qtyBox.classList.remove('hidden');
      qtyValue.textContent = qty;
    } else {
      form.style.display = '';
      qtyBox.classList.add('hidden');
      qtyValue.textContent = '0';
    }

    if (plusBtn) {
      plusBtn.classList.toggle(
        'is-disabled',
        Number.isFinite(limit) && limit > 0 && qty >= limit
      );
    }
  }

  function syncCollectionUIs(productId, qty, limit) {
    document
      .querySelectorAll(`.collection-atc-wrapper[data-product-id="${productId}"]`)
      .forEach((wrapper) => {
        setCollectionUI(wrapper, qty, limit);
      });
  }

  function syncCartLineUI(productId, qty) {
    document
      .querySelectorAll(`[data-cart-line][data-product-id="${productId}"]`)
      .forEach((line) => {
        const inputs = line.querySelectorAll('input[name="updates[]"]');

        inputs.forEach((input) => {
          input.value = qty;
        });

        const lineKey = line.dataset.lineKey;
        const limit = parseInt(line.dataset.bottlePurchaseLimit, 10);
        const links = line.querySelectorAll('a[href*="/cart/change"]');

        links.forEach((link) => {
          const url = new URL(link.href, window.location.origin);

          const isPlus = !!link.querySelector('.icon-plus');
          const isMinus = !!link.querySelector('.icon-minus');

          if (isPlus) {
            url.searchParams.set('quantity', String(qty + 1));
            link.classList.toggle(
              'is-disabled',
              Number.isFinite(limit) && limit > 0 && qty >= limit
            );
          }

          if (isMinus) {
            url.searchParams.set('quantity', String(Math.max(0, qty - 1)));
          }

          if (lineKey) {
            url.searchParams.set('id', lineKey);
          }

          link.href = url.pathname + url.search;
        });
      });
  }

  function replaceCartDrawerFromHtml(html) {
    if (!html) return;

    const currentDrawer = document.querySelector('cart-drawer#cart-drawer');
    if (!currentDrawer) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const updatedDrawer = parsed.querySelector('cart-drawer#cart-drawer');

    if (!updatedDrawer) return;

    currentDrawer.replaceWith(updatedDrawer);
    updateCartLimitButtonStates();
  }

  function updateCartLimitButtonStates() {
    document.querySelectorAll('[data-cart-line]').forEach((line) => {
      const limit = parseInt(line.dataset.bottlePurchaseLimit, 10);

      if (!Number.isFinite(limit) || limit <= 0) return;

      const input = line.querySelector('input[name="updates[]"]');
      if (!input) return;

      const qty = parseInt(input.value, 10);
      const atLimit = Number.isFinite(qty) && qty >= limit;

      line.querySelectorAll('a[href*="/cart/change"]').forEach((link) => {
        if (link.querySelector('.icon-plus')) {
          link.classList.toggle('is-disabled', atLimit);
        }
      });
    });
  }

  // ADD TO CART LIMIT CHECK
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      if (form.dataset.bottleLimitChecked === 'true') {
        delete form.dataset.bottleLimitChecked;
        return;
      }

      if (!form.matches('form[action*="/cart/add"]')) return;

      const productForm = form.closest('product-form');
      if (!productForm) return;

      const productId = productForm.dataset.productId;
        const limit = parseInt(productForm.dataset.bottlePurchaseLimit, 10);
        const hasLimit = Number.isFinite(limit) && limit > 0;

        if (!productId) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const qtyInput = form.querySelector('[name="quantity"]');
        const addQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        const cart = await getCart();
        const currentQty = productQtyInCart(cart, productId);

        if (hasLimit && currentQty + addQty > limit) {
        showMessage(productForm, limit);
        return;
        }

      const nextQty = currentQty + addQty;
      const cardWrapper = form.closest('.collection-atc-wrapper');

      if (cardWrapper) {
        setCollectionUI(cardWrapper, nextQty, limit);
      }

      syncCollectionUIs(productId, nextQty, limit);
      syncCartLineUI(productId, nextQty);
      updateCartLimitButtonStates();

      form.dataset.bottleLimitChecked = 'true';
      form.requestSubmit();
    },
    true
  );

  // COLLECTION QUANTITY SELECTOR
  document.addEventListener(
    'click',
    async (event) => {
      const plus = event.target.closest('.qty-plus');
      const minus = event.target.closest('.qty-minus');

      if (!plus && !minus) return;

      const wrapper = event.target.closest('.collection-atc-wrapper');
      if (!wrapper) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (wrapper.dataset.updating === 'true') return;
      wrapper.dataset.updating = 'true';

      const productId = wrapper.dataset.productId;
      const limit = parseInt(wrapper.dataset.bottlePurchaseLimit, 10);

      const cart = await getCart();
      const item = cart.items.find((cartItem) => String(cartItem.product_id) === String(productId));

      if (!item) {
        setCollectionUI(wrapper, 0, limit);
        wrapper.dataset.updating = 'false';
        return;
      }

      let newQty = item.quantity;

      if (plus) {
        if (Number.isFinite(limit) && limit > 0 && item.quantity >= limit) {
          showMessage(wrapper, limit);
          wrapper.dataset.updating = 'false';
          return;
        }

        newQty = item.quantity + 1;
      }

      if (minus) {
        newQty = Math.max(0, item.quantity - 1);
      }

      const cartChangeResponse = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: newQty,
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      });

      const cartChangeData = await cartChangeResponse.json();

      if (cartChangeData.sections && cartChangeData.sections['cart-drawer']) {
        replaceCartDrawerFromHtml(cartChangeData.sections['cart-drawer']);
      }

      syncCollectionUIs(productId, newQty, limit);
      syncCartLineUI(productId, newQty);
      updateCartLimitButtonStates();

      wrapper.dataset.updating = 'false';
    },
    true
  );

  // CART DRAWER / CART PAGE +/- LIMIT CHECK
  document.addEventListener(
    'click',
    async (event) => {
      const link = event.target.closest('a[href*="/cart/change"]');
      if (!link) return;

      const line = link.closest('[data-cart-line]');
      if (!line) return;

      const productId = line.dataset.productId;
      const limit = parseInt(line.dataset.bottlePurchaseLimit, 10);

      if (!productId || !Number.isFinite(limit) || limit <= 0) return;

      const url = new URL(link.href, window.location.origin);
      const newQty = parseInt(url.searchParams.get('quantity'), 10);

      if (!Number.isFinite(newQty)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const cart = await getCart();
      const totalQty = productQtyInCart(cart, productId);
      const currentLine = cart.items.find((item) => item.key === line.dataset.lineKey);
      const currentLineQty = currentLine ? currentLine.quantity : 0;
      const otherQty = totalQty - currentLineQty;

      if (otherQty + newQty > limit) {
        showMessage(line, limit);
        updateCartLimitButtonStates();
        return;
      }

      const changeResponse = await fetch(link.href, {
        headers: { Accept: 'application/json' }
      });

      const updatedCart = await getCart();
      const updatedQty = productQtyInCart(updatedCart, productId);

      syncCollectionUIs(productId, updatedQty, limit);
      syncCartLineUI(productId, updatedQty);
      updateCartLimitButtonStates();

      const drawerHtml = await fetch(`${window.location.pathname}?sections=cart-drawer`)
        .then((res) => res.json())
        .then((sections) => sections['cart-drawer'])
        .catch(() => null);

      replaceCartDrawerFromHtml(drawerHtml);
    },
    true
  );

  // CART DRAWER / CART PAGE MANUAL INPUT LIMIT CHECK
  document.addEventListener(
    'input',
    (event) => {
      const input = event.target;

      if (!(input instanceof HTMLInputElement)) return;
      if (!input.matches('input[name="updates[]"]')) return;

      const line = input.closest('[data-cart-line]');
      if (!line) return;

      const productId = line.dataset.productId;
      const limit = parseInt(line.dataset.bottlePurchaseLimit, 10);
      const val = parseInt(input.value, 10);

      if (Number.isFinite(limit) && limit > 0 && Number.isFinite(val) && val > limit) {
        input.value = limit;
        showMessage(line, limit);
        syncCollectionUIs(productId, limit, limit);
        syncCartLineUI(productId, limit);
        updateCartLimitButtonStates();
      }
    },
    true
  );

  // SYNC UI ON LOAD
  document.addEventListener('DOMContentLoaded', async () => {
    const cart = await getCart();

    document.querySelectorAll('.collection-atc-wrapper').forEach((wrapper) => {
      const productId = wrapper.dataset.productId;
      const limit = parseInt(wrapper.dataset.bottlePurchaseLimit, 10);
      const qty = productQtyInCart(cart, productId);

      setCollectionUI(wrapper, qty, limit);
    });

    cart.items.forEach((item) => {
      syncCartLineUI(String(item.product_id), item.quantity);
    });

    updateCartLimitButtonStates();
  });
})();